import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import { useUser } from '../stores/authStore';
import type { Word } from '../types';

const fetchWords = async (user_id: string | undefined) => {
  const { data: words, error: wordsError } = await supabase
    .from('words')
    .select('*')
    .order('word');

  if (wordsError) {
    throw new Error(wordsError.message);
  }

  if (!user_id) {
    return words.map(word => ({ ...word, user_progress: undefined }));
  }

  const { data: progress, error: progressError } = await supabase
    .from('user_progress')
    .select('*')
    .eq('user_id', user_id);

  if (progressError) {
    console.error('Failed to fetch user progress', progressError);
    return words.map(word => ({ ...word, user_progress: undefined }));
  }

  const wordsWithProgress: Word[] = words.map(word => {
    const user_progress = progress.find(p => p.word_id === word.id);
    return { ...word, user_progress };
  });

  return wordsWithProgress;
};

export const useWords = () => {
  const user = useUser();
  return useQuery<Word[], Error>({
    queryKey: ['words', user?.id],
    queryFn: () => fetchWords(user?.id),
  });
};